import axios from "axios";

import { registrationsSet } from "./user";
import { getAuthHeader } from "../headers";

// ===================================================================================
//  REGISTER REVIEWER FOR REVIEW
// ===================================================================================
export const registrationInProcess = () => {
	return {
		type: "REGISTRATION_IN_PROCESS"
	};
};

export const registrationHasError = err => {
	return {
		type: "REGISTRATION_HAS_ERROR",
		error: err
	};
};

export const registrationSuccess = data => {
	return {
		type: "REGISTRATION_SUCCESS",
		data
	};
};

export const clearRegistrationResults = () => {
	return {
		type: "REGISTRATION_RESULTS_CLEAR"
	};
};

export function registerReviewerToRegistration(reviewId, reviewer = null) {
	return (dispatch, getState) => {
		dispatch(registrationInProcess());
		let reviewerId = reviewer === null ? getState().user.reviewer.id : null;
		let params = {};
		if (reviewer === null) {
			// Pass reviewId and reviewerId (if administrator)
			params = {
				reviewId,
				reviewerId
			};
		} else {
			params = {
				reviewId,
				reviewer
			};
		}

		// Add id of record to find if passed
		const endPoint = `register`;

		return axios
			.post(process.env.REACT_APP_API_URL + endPoint, params, {
				headers: getAuthHeader(getState().user, !!reviewer)
			})
			.then(response => {
				if (response.data.status && response.data.status !== 200) {
					if (response.data.message !== "") {
						dispatch(registrationHasError(response.data.message));
					} else {
						dispatch(registrationHasError(response.data.errors));
					}
				} else {
					// If an admin has passed in a reviewer, we don't want to update registration records
					if (reviewer === null) {
						dispatch(registrationsSet(response));
					}
					return dispatch(registrationSuccess(response));
				}
			})
			.catch(err => {
				dispatch(registrationHasError(err.response.data.message));
			});
	};
}


// WEBPACK FOOTER //
// ./src/store/actions/registration.js